import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { HelmetProvider } from 'react-helmet-async'
import { SecurityProvider } from './components/SecurityProvider'

// Defer Sentry initialization until after first paint to improve LCP
setTimeout(() => {
  import('./lib/sentry').then(({ initSentry, trackWebVitals }) => {
    initSentry();
    trackWebVitals();
  });
}, 0);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <SecurityProvider>
      <App />
    </SecurityProvider>
  </HelmetProvider>
);
